import { ITask } from '@app/models/task.model';

export interface State {
    tasks: ITask[];
    selectedTask: ITask;
    allowAddTask: boolean;
}

export const initializeTasksState = (): State => {
    return {
        tasks: [],
        selectedTask: undefined,
        allowAddTask: true
    };
};
